<template>
	<div class="guide-box">
		<div class="guide-bg-box"></div>
		<div class="guide-infor-box">
			<div class="guide-infor-bg">
				高考结束后，学生将面临高考志愿填报。志愿填报，说简单只要做到9个字，即“凭实力、选学校、择专业”，可如何找准自己的定位和方向，如何评估报考院校的实力，并把这二者完美结合，说难也比较难。阳光高考平台继续推出高考填报志愿指南专题，为考生家长详解志愿设置和录取规则，邀请高校招办解读学校新政，提供全方位的帮助和服务！
			</div>
		</div>
		<div class="guide-tips-box">
			<div class="guide-tips-title">
				<div v-for="(item, index) in tips_list" :key="index" class="guide-tips-title-item" :class="active_index === index ? 'guide-tips-title-item-active' : ''" @click="changeDescActive(index)">
					{{ item }}
				</div>
			</div>
			<div v-if="active_index === 0" class="guide-desc-common-box">
				<h3>
					<span>名词解释</span>
					<div class="guide-desc-line"></div>
				</h3>
				<div v-for="(item, index) in desc_list1" :key="index" class="guide-desc-common-item">
					<h5>{{ item.title }}</h5>
					<p v-html="item.desc"></p>
				</div>
			</div>
			<div v-else-if="active_index === 1" class="guide-desc-common-box guide-desc-zhengce-box">
				<h3>
					<span>政策解读</span>
					<div class="guide-desc-line"></div>
				</h3>
				<div v-for="(item, index) in desc_list2" :key="index" class="guide-desc-common-item">
					<el-row>
						<el-col :span="index < 2 ? 13: 24">
							<h5>{{ item.title }}</h5>
							<p v-html="item.desc"></p>
						</el-col>
						<el-col v-if="index < 2" :span="11" style="text-align: right">
							<img :src="require('../../assets/images/gk-guide-zhengce-img' + (index + 1) + '.png')" alt="">
						</el-col>
					</el-row>
				</div>
			</div>
			<div v-else-if="active_index === 2" class="guide-desc-common-box guide-desc-zhiyuan-box">
				<h3>
					<span>志愿模式</span>
					<div class="guide-desc-line"></div>
				</h3>
				<div v-for="(item, index) in desc_list3" :key="index" class="guide-desc-common-item">
					<h4>{{ item.title }}</h4>
					<h5>{{ item.title1 }}</h5>
					<p v-html="item.desc1"></p>
					<h5>{{ item.title2 }}</h5>
					<p v-html="item.desc2"></p>
					<h5 v-if="item.title3">{{ item.title3 }}</h5>
					<p v-if="item.title3" v-html="item.desc3"></p>
				</div>
			</div>
			<div v-else-if="active_index === 3" class="guide-desc-common-box guide-desc-gaige-box">
				<h3>
					<span>高考改革</span>
					<div class="guide-desc-line"></div>
				</h3>
				<h4>从2014年国务院印发《关于深化考试招生制度改革的实施意见》以来，全国已经有21个省份分四批启动了高考综合改革。在已启动新高考模式的省市中，有两种不同的选考模式：“3+3”模式和“3+1+2”模式。</h4>
				<div v-for="(item, index) in desc_list4" :key="index" class="guide-desc-common-item">
					<h5>{{ item.title }}</h5>
					<p v-html="item.desc"></p>
				</div>
			</div>
			<div v-else-if="active_index === 4" class="guide-desc-common-box guide-desc-moshi-box">
				<h3>
					<span>3+1+2模式</span>
					<div class="guide-desc-line"></div>
				</h3>
				<div class="guide-desc-moshi-title">高考成绩构成</div>
				<h4>“3+1+2”模式，考试科目由3门全国统考科目和3门学业水平选择性考试科目组成。</h4>
				<div class="guide-moshi-grade-box">
					<div class="guide-moshi-grade-item">
						<div v-for="(item, index) in
						grade_list">
							<div class="guide-moshi-subject-box">
								<div class="guide-moshi-subject-index">{{ item.id }}</div>
								<h4>{{ item.title }}</h4>
								<div v-for="(item1, index1) in item.subject" :key="index1" class="guide-moshi-subject-item">
									<span>{{ item1.name }}</span>
									<span>{{ item1.score }}</span>
								</div>
								<div class="guide-moshi-grade-total">
									<h6>以原始成绩计入总分</h6>
									<h3>{{ item.total_score }}</h3>
								</div>
							</div>
							<span v-if="index < 2" class="guide-moshi-grade-add">+</span>
						</div>
					</div>
					<div class="guide-moshi-grade-deng">=</div>
					<div class="guide-moshi-grade-total guide-moshi-grade-total-diff">
						<h6>总分</h6>
						<h3>750分</h3>
					</div>
				</div>
				<div class="guide-desc-moshi-title">志愿填报</div>
				<div v-for="(item, index) in desc_list5" :key="index" class="guide-desc-common-item">
					<h5>{{ item.title }}</h5>
					<div class="guide-desc-moshi-city">
						<span v-for="(item1, index1) in item.city" :key="index1">{{ item1 }}</span>
					</div>
					<p v-html="item.desc"></p>
				</div>
			</div>
			<div v-else-if="active_index === 5" class="guide-desc-common-box guide-desc-yaoqiu-box">
				<h3>
					<span>选考科目要求</span>
					<div class="guide-desc-line"></div>
				</h3>
				<el-row :gutter="20" type="flex" style="flex-wrap: wrap;" v-if="requestStatus === '1'">
					<el-col v-for="(item, index) in new_list" :key="index" :span="12" @click.native="goDetailHandler(item.id)">
						<div class="guide-desc-common-item">
							<h5>
							{{ item.list[0] }}
							<i :class="!item.list[0]?'el-icon-arrow-right-diff':''" class="el-icon-arrow-right"></i>
							</h5>
							<el-tooltip :content="item.list[1]" placement="bottom" effect="light">
	  							<p v-html="item.list[1]"></p>
							</el-tooltip>
						</div>
					</el-col>
				</el-row>
				<div class="no-data-box" v-else-if="requestStatus === '2'">
                    <img src="../../assets/images/null.png" alt="没有数据">
                    <p>暂无数据</p>
                </div>
			</div>
			<div v-else class="guide-desc-common-box">
				<h3>
					<span>填报技巧</span>
					<div class="guide-desc-line"></div>
				</h3>
				<div v-for="(item, index) in desc_list7" :key="index" class="guide-desc-common-item">
					<h5>{{ item.title }}</h5>
					<p v-html="item.desc"></p>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { getGuideList } from '@/api/news'
export default {

	name: 'Guide',

	data() {
		return {
			requestStatus: '1',
			tips_list: ['名词解释', '政策解读', '志愿模式', '高考改革', '3+1+2模式', '选考科目要求', '填报技巧'],
			active_index: 0,
			desc_list1: [
			{
				title: '1、录取分数线',
				desc: '分数线即录取分数线、省控线、填报志愿的资格线，是指各省份招生主管部门（省教育考试院或招办）根据高校招生计划、考生人数、成绩分布，按照一定比例所确定的高校录取最低分数。<br>一般按批次划分，如一本分数线、二本分数线、专科分数线。低于这个分数的考生不得填报志愿，高校也不得录取。分数线是考生和家长在志愿填报中最关注的内容。分数线直观地反映了院校往年的录取情况，是当年院校、专业录取考生层次的基本反映。'
			},{
				title: '2、院校投档线',
				desc: '省招生主管部门根据考生志愿填报的分布情况，按照志愿院校规定的比例确定向志愿高校投递考生电子档案的最低分数，这个分数就叫投档线，相对于院校来说又叫提档线，又称调档线、进档线。<br>值得注意的是，考生高考成绩总分达到了录取分数线是具备了填报志愿的资格，但填报了志愿未必达到某志愿院校的提档线，如果达不到，电子档案不能投放，就参加不了该志愿的录取。由于每个院校所报考生的人数不同、考生分数分布不同，投档线也就各不相同。'
			},{
				title: '3、投档比例',
				desc: '即调档比例，是指某一院校在考生所在省（自治区、直辖市）调阅考生档案数与院校招生计划数之间的比例。实行平行志愿投档模式的地区，院校的投档比例一般在100%～110%，并在各院校的《招生章程》予以公布。<br>例如，一本批次的某高校在某省当年招生计划为100人，公布的投档比例为110%，那么，省级招生部门在录取投档时，在生源充足的情况下，则要向该校投档110人，供高校择优录取。该省招办向该高校首次投档，其中第110人的分数，就是该校当年在该省的调档线。这110人经该高校按“德智体”全面考核后，选择录取其中的100人，其第100人的分数，就是该校当年在该省的实录线或叫最低录取线。<br>一般来说，实录线≥调档线≥省控线。'
			},{
				title: '4、录取批次',
				desc: '录取批次是省招生主管部门为高效开展录取工作和优先照顾重点院校的录取，划分时间段分期分批地录取。一般分为：提前批次；本科一批次；本科二批次；专科批次。<br>提前批次，是军事院校、公安院校、艺术和体育类等院校录取批次；<br>本科一批次，是重点大学录取批次；<br>本科二批次，是一般普通院校、独立学院、民办院校录取批次。<br>专科批次，是专科类公办、民办院校的录取批次。<br>'
			},{
				title: '5、线差',
				desc: '线差分可分为考生线差分、高校录取线差分。<br>考生线差分=考生的高考总分-省控分数线<br>如李同学高考成绩500分，所在省份二本分数线为485分，那么该生线差分就是15分。<br>院校录取线差分=投档分数线-省控分数线<br>如X大学录取投档线为505分，某省二本省控线为485分，那么该校录取线差分为20分。<br>线差的作用主要用于对不同年度的录取分数进行分析和比较，因为很多院校在不同年度的录取分经常会发生很大变化，但录取线差波动一般不会太大。'
			},{
				title: '6、专业级差',
				desc: '专业级差就是院校在安排考生录取专业时，按照《招生章程》公布的一个或几个分数值确定考生所录取的专业，这个分数值叫专业级差。<br>如，当年某高校在当年招生章程中规定：设置专业分数级差，前四个专业志愿及调剂志愿依次为5、3、1、1分，即当考生第一志愿专业不能录取时，将该考生高考分数减去5分，看是否满足第二志愿专业录取条件，如果第二志愿专业还不能录取，那么，再将该考生高考分数减去3分，看是否符合第三专业录取条件，依次类推直到最后一个志愿专业。'
			},{
				title: '7、梯度',
				desc: '在志愿填报中的梯度只表示两个或几个院校之间录取线差值的大小。考生地选报志愿时要注意使院校与专业之间形成合理的梯度，以免造成滑档、进档退档或死档的风险。'
			},{
				title: '8、各种志愿',
				desc: '院校志愿是考生对高校志向的选择。<br>专业志愿是考生根据自己的兴趣爱好、性格特点、发展潜能对院校中一个或几个专业所作出的选择。院校志愿和专业志愿统称为高考志愿。<br>无效志愿就是对考生投档录取没有意义或无用的志愿，它有两种情况：<br>一是由于考生笔误或填错或涂错院校代码，电脑无法按考生的原本意思显示或运行(在实际志愿填报时系统会报错而无法提交)；<br>二是在同一批次院校志愿之间没有形成梯度或反向梯度关系，如果考生第一志愿没有被录取，其后的各个志愿都不会被录取。<br>第一志愿就是考生在一批次中填报在志愿栏目中第一位置的志愿，是考生最理想最希望被录取的院校志愿，其余依次类推。'
			},{
				title: '9、大小年现象',
				desc: '大小年现象是某些院校在历年招生录取中，报考人数(批次最低控制线上)很不稳定、起伏较大，引起该校录取线较大幅度波动的趋势。'
			},{
				title: '10、一分一段表',
				desc: '历年来的高考成绩分数段（一分一段）是很重要的填报志愿的依据，也是各大高校划自己分数线的一部分依据。一分一段表是从高到低的排名，考生根据成绩对照一分一段表，就可以知道自己在全省的排名，再参照各类学校各批次招生计划数，确定自己该如何填报志愿。<br>了解自己：计算出你的全省排名，结合同等梯度的高校招生计划总数，弄清自己所处的位置。<br>考生在“知分、知线、知位”的情况下填报志愿，一分一段表是很客观的参考数据。考生一定要认真分析，清楚自己的排位，从而正确填报学校。尤其是高分段的考生，更要好好地研究排名，排名在某种程度上决定了你能去哪所大学、学习什么样的专业。<br>举例：一个学生高考总分600分，对应该分段的考生人数是11100人，往上面一分599分对应分段的考生人数是11000人，那么也就是说今年该省有100人考了600分，对应的名次是从11001名到11100名。'
			},{
				title: '11、投档',
				desc: '投档是指各地招办根据考生分数、考生志愿填报情况和各大学在该地的招生计划以及调档比例，把考生档案投放给招生学校。学校在接收到投档过来的学生档案之后，开始安排专业录取。投档只是高考招生的第一步，专业录取才是最后结果。'
			},{
				title: '12、调档比例',
				desc: '调档比例，是指一个院校调阅考生电子档案数与计划招生数的比例，一般不超过120%。投档比例就是解决投档多少合适的问题。它以招生院校为单位，是同一批次、同一计划性质、同一科类的招生计划数与投放考生档案数量之间的比例。一方面，由于教育部规定普通高校的招生投档比例一般不得超过120%；另一方面，招生院校为了既顺利完成招生计划，同时又保证招生质量，故确定的投档比例一般都100%—120%之间。'
			},{
				title: '13、线差',
				desc: '线差很好理解，就是某校的提档线减去当年该批次的省控线，比如去年理科一批省控线是518分，郑州大学的理科提档线是603分，那么郑大的理科线差就是85分，线差作为高考填报志愿时重要的参考数据，可以在粗选目标大学时使用。'
			},{
				title: '14、调剂',
				desc: '专业调剂，是指当考生所有专业志愿均无法录取时，高校可将考生调剂到未录取满额的专业。'
			},{
				title: '15、滑档',
				desc: '滑档，是指考生整个批次志愿都无法投出，所有志愿学校都没有达到投档线。'
			},{
				title: '16、退档',
				desc: '考生被退档是指考生的单科成绩、身体条件不符合招生简章的要求之外，最主要的原因是考生不服从专业调剂。如果考生被不合理地退档，应及时与有关高校联系。'
			},{
				title: '17、单列专业',
				desc: '单列专业是一个大的概念，包括中外合作、医护类、软件类、农林类等。因高校部分专业办学模式、培养方向、学费标准等与普通专业不同，需要单独拿出来招生。单列专业内部调剂，但不与普通专业调剂，招生代码也不相同并且占用一个志愿指标。'
			},{
				title: '18、按大类招生',
				desc: '按大类招生是高校将相同或相近学科门类专业合并，按一个大类招生。通过该方式录取的学生在本科阶段先统一学习基础课，一段时间后再根据自己的学习兴趣和学校的专业设置情况，按照双向选择的原则最终确定所学专业。考生在报考按大类招生的专业时，要了解大类中都包含哪些专业（方向）。'
			},{
				title: '19、三大专项计划',
				desc: '根据教育部政策，重点高校招收农村和脱贫地区学生计划统称为“专项计划”，具体包括：国家、地方、高校三个专项计划。国家专项计划面向脱贫地区定向招生。地方专项计划定向招收各省(区、市)实施区域的农村学生。高校专项计划定向招收边远、原贫困、民族等地区县(含县级市)以下高中勤奋好学、成绩优良的农村学生。'
			},{
				title: '20、优师计划',
				desc: '优师计划即优秀教师定向培养专项计划，旨在为中西部欠发达地区中小学校定向培养一批优秀教师，推动欠发达地区教育优质均衡发展。优师专项分为国家优师专项和地方优师专项。国家优师专项由6所教育部直属师范大学承担培养任务，面向中西部省份招生。地方优师专项由中西部省级教育行政部门确定的本科层次师范院校承担培养任务。'
			}],
			desc_list2: [
			{
				title: '1、平行志愿投档图解',
				desc: '如右图所示。平行志愿按照“分数优先，遵循志愿，一轮投档”的原则进行投档，对同一科类分数线上未被录取的考生按总分从高到低排序进行一次性投档，即所有考生排一个队列，高分者优先投档。每个考生投档时，根据考生所填报的院校顺序，投档到排序在前且有计划余额的院校。'
			},{
				title: '2、顺序志愿投档图解',
				desc: '如右图所示。顺序志愿是在同一个录取批次设置的多个院校志愿有先后顺序，如第一志愿、第二志愿等，每个志愿只包括一所院校。顺序志愿的投档原则是“志愿优先，从高分到低分”，把考生的高考志愿作为录取投档的第一要素，最大程度地满足考生的志愿要求。顺序志愿投档时，对选报同一志愿院校的考生按院校确定的录取原则、调档比例从高分到低分进行投档，也就是说每所院校各排各的队。'
			},{
				title: '3、平行志愿与顺序志愿的区别',
				desc: '平行志愿投档比例原则上控制在105%以内。平行志愿对同一科类批次线上未被录取的考生按成绩从高分到低分排序进行一次性投档。本科平行投档时根据考生所填报志愿院校顺序，投档到排序在前且有计划余额的高校。分数优先，是指招办按考生总分排序后依次投档，比如说，某考生所报志愿为A、B、C、D等四所院校，录取时，批次线上考生先按分数大排队，然后由计算机逐一检索考生志愿，如果考生符合A校投档条件，且A校有计划余额，则投档到A校；如果不符合A校的投档条件，则检索B校，依此类推，直到检索到考生分数符合的院校后，将其投档至该校。档案一旦投出，即不再检索该生其它志愿。<br> 顺序志愿投档比例原则上控制在120%以内。顺序志愿把考生的高考志愿作为录取投档的第一要素，最大程度地满足考生的志愿要求。对选报同一志愿院校的考生按院校确定的调档比例从高分到低分进行投档，第一志愿录取结束后，若高校招生计划未完成，再进行第二志愿投档录取。举个例子来说，一旦考生将某高校放在第二志愿，即使你分数再高，如果该校一志愿已经招满了且不预留招收二志愿的名额，你的档案也不会投向该校。'
			},{
				title: '4、平行志愿是否有风险？',
				desc: '有。相对顺序志愿填报方式而言，平行志愿在一定程度上降低了志愿填报风险，但平行志愿同样存在一定的风险。<br> 按照平行志愿投档的批次，提档比例原则上控制在105%以内，投档人数多于录取人数。如某高校招生计划为100人，提档比例为102%，则被提档的102名考生中，肯定有2人面临退档风险，分数越接近投档线的考生风险越大。<br> 考生虽然达到了学校的投档分，却没有达到所报的专业分，而又不服从专业调剂，也有可能被退档。<br> 考生不服从专业调剂、体检不合格、单科成绩不符合高校要求等因素，都有可能造成退档。这些因素由高校根据招生需要自主设定，并在高校招生章程中公布。<br>考生一旦投档到某个高校，又不符合高校招生章程的要求就会造成退档。因此考生在填报志愿前一定要认真查看高校招生章程，防止因误报而被退档，从而失去这一次录取的机会。'
			},{
				title: '5、如何读懂招生章程？',
				desc: '在阅读高校招生章程时，除了看学校的性质层次、办学类型、收费标准等信息外，考生还要认真阅读很多重要信息，如调档比例、退档情况、加分政策、单科成绩要求、身体受限、专业级差、外语语种、专业报考等具体要求。高校招生章程中的录取规则会使用一些专业术语，如“调档比例”“退档”“专业级差”等。对这些术语，考生和家长不能想当然，可以通过查阅资料、向高校咨询等方式来弄清其具体含义。 <br>比如，一些医科大学或医学类专业对色盲、色弱及其他各类不能准确识别颜色者不予录取，具体是怎样规定的。考生在报考时，应仔细阅读招生章程，注意这些身体条件的限制，以免出现因身体条件退档的情况。'
			},{
				title: '6、举例详解“专业级差”',
				desc: '假设学生小明报考A高校，考了560分，其专业志愿分别为：计算机、国际贸易、自动化、机械工程、电子商务，A高校的专业录取实行专业级差的办法，级差分为2分、1分、1分、0分。在进行专业分配时，如果小明的第一专业志愿符合专业录取要求且专业有计划余额，那么小明被录取到“计算机”专业;若计算机未被录取，则他的分数将会被减去2分(即558分)，按558分的成绩同第一专业志愿报考“国际贸易”的考生排序，确定是否符合专业录取条件;倘若仍不能满足，分数再减去1分(即557分)进行第三专业志愿“自动化”的录取;若依旧不能满足，分数再被减去1分(即556分)进行第四专业的录取，后续专业如果仍不能满足其专业志愿，将不再减分，以此类推。'
			},{
				title: '7、哪些考生可以填报征集志愿？',
				desc: '征集志愿是指每一批次录取结束之后，省级招办将录取未满额的院校和余缺计划数向社会进行公布，供尚未被录取并达到分数要求的考生进行选报。<br> 达到分数要求且未被录取的考生才能填报。这一句话有两个重点：第一是未被录取的考生。已经被高校录取的考生不能参加征集志愿。第二是分数达到要求，即符合本批录取控制线或降低一定分数，但是否降分要看院校具体要求，一般来说会先征集线上考生。'
			},{
				title: '8、参加征集志愿需要注意什么？',
				desc: '1.考生要注意及时关注省市招办官方渠道公布的余缺信息，必须在规定的时间内登录省招办公布的志愿填报网站完成填报。2.按规定选报院校志愿和院校服从调剂志愿。同时要符合院校和专业的报考及体检要求。3.考生选报征集志愿时要考虑避免再次出现“扎堆”落选的问题。有的考生认为参加征集志愿的高校录取分数一定会降低，其实不然。高校的录取分数是否降低，取决于缺额的高校计划的数量和报考人数。4.考生参加征集志愿时要谨慎选择，考虑清楚所报院校剩余的专业自己能否接受，一旦被录取就不能退档调换。'
			},{
				title: '9、如何报考“三大专项计划”?',
				desc: '报考国家专项计划考生均须参加当年全国统一考试。根据各省招办要求填报志愿。 <br>报考地方专项计划的考生均须参加当年全国统一考试。具体报名要求、录取办法、填报志愿方式考生可详细阅读各省招生考试单位下发的地方专项计划相关规定。<br> 报考高校专项计划考生须参加当年全国统一考试，并在规定时间内（一般是在4月中旬），登录阳光高考高校专项计划报名系统完成报名申请。<br> 地方专项计划和高校专项计划实施区域的农村范围由各省（区、市）根据本地实际情况确定。考生可根据各省市招办发布的相关规定，查看具体实施区域。'
			},{
				title: '10、“三大专项计划”如何录取?',
				desc: '国家专项计划录取办法，在本科一批前开始投档录取，录取分数原则上不低于招生学校所在批次科类录取控制分数线。对于合并本科录取批次的有关省份，国家专项计划在本科批次前开始投档录取，录取分数不低于本科批次录取控制分数线。 <br>地方专项计划的投档办法和录取要求，由各省（区、市）综合有关高校招生实际、实施区域农村招生情况等因素确定。 <br>高校专项计划录取办法由有关高校确定并在招生简章中明确，录取分数原则上不低于有关高校普通类招生所在批次录取控制分数线。'
			},{
				title: '11、近视考生有哪些专业受限?',
				desc: '根据《普通高等学校招生体检工作指导意见》中对考生视力的相关要求，特摘要如下，供参考：<br> 患有下列疾病者，学校有关专业可不予录取 <br>4、裸眼视力任何一眼低于5.0者，不能录取的专业：飞行技术、航海技术、消防工程、刑事科学技术、侦察。专科专业：海洋船舶驾驶及与以上专业相同或相近专业(如民航空中交通管制)。<br> 5、裸眼视力任何一眼低于4.8者，不能录取的专业：轮机工程、运动训练、民族传统体育。专科专业：烹饪与营养、烹饪工艺等。 <br>7、公安普通高等学校招生身体条件。 <br>左右眼单眼裸视力，理科类专业应在4.9(0.8)以上，文科类专业应4.8(0.6)以上。无色盲、色弱。 <br><br><br>患有下列疾病不宜就读的专业<br> 4、屈光不正(近视眼或远视眼，下同)任何一眼矫正到4.8镜片度数大于400度的，不宜就读海洋技术、海洋科学、测控技术与仪器、核工程与核技术、生物医学工程、服装设计与工程、飞行器制造工程。专科专业：与以上相同或相近专业。<br> 5、任何一眼矫正到4.8镜片度数大于800度的，不宜就读地矿类、水利类、土建类、动物生产类、水产类、材料类、能源动力类、化工与制药类、武器类、农业工程类、林业工程类、植物生产类、森林资源类、环境生态类、医学类、心理学类、环境与安全类、环境科学类、电子信息科学类、材料科学类、地质学类、大气科学类及地理科学、测绘工程、交通工程、交通运输、油气储运工程、船舶与海洋工程、生物工程、草业科学、动物医学各专业。专科专业：与以上相同或相近专业。 <br>6、一眼失明另一眼矫正到4.8镜片度数大于400度的，不宜就读工学、农学、医学、法学各专业及应用物理学、应用化学、生物技术、地质学、生态学、环境科学、海洋科学、海洋技术、生物科学、应用心理学等专业。'
			},{
				title: '12、色盲、色弱考生要避开什么专业?',
				desc: '参见《普通高等学校招生体检工作指导意见》患有下列疾病者，学校有关专业可不予录取<br> 1、轻度色觉异常(俗称色弱)不能录取的专业：以颜色波长作为严格技术标准的化学类、化工与制药类、药学类、生物科学类、公安技术类、地质学类各专业，医学类各专业;生物工程、生物医学工程、动物医学、动物科学、野生动物与自然保护区管理、心理学、应用心理学、生态学、侦察学、特种能源工程与烟火技术、考古学、海洋科学、海洋技术、轮机工程、食品科学与工程、轻化工程、林产化工、农学、园艺、植物保护、茶学、林学、园林、蚕学、农业资源与环境、水产养殖学、海洋渔业科学与技术、材料化学、环境工程、高分子材料与工程、过程装备与控制工程、学前教育、特殊教育、体育教育、运动训练、运动人体科学、民族传统体育各专业。<br> 2、色觉异常Ⅱ度(俗称色盲)不能录取的专业，除同轻度色觉异常外，还包括美术学、绘画、艺术设计、摄影、动画、博物馆学、应用物理学、天文学、地理科学、应用气象学、材料物理、矿物加工工程、资源勘探工程、冶金工程、无机非金属材料工程、交通运输、油气储运工程等专业。专科专业与以上专业相同或相近专业。<br> 3、不能准确识别红、黄、绿、蓝、紫各种颜色中任何一种颜色的导线、按键、信号灯、几何图形者不能录取的专业;除同轻度色觉异常、色觉异常Ⅱ度两类列出专业外，还包括经济学类、管理科学与工程类、工商管理类、公共管理类、农业经济管理类、图书档案学类各专业。不能准确在显示器上识别红、黄、绿、蓝、紫各颜色中任何一种颜色的数码、字母者不能录取到计算机科学与技术等专业。'
			}],
			desc_list3: [
			{
				title: '平行志愿',
				title1: '一、平行志愿是什么',
				desc1: '平行志愿是指在每个录取批次的学校中，考生可填报若干个平行的学校，然后按“分数优先、遵循志愿”的原则进行投档录取。',
				title2: '二、平行志愿录取规则',
				desc2: '即分数优先，遵循志愿，一轮投档。<br>分数优先：首先将所有考生分文史、理工类按投档分从高到低位次排列。投档检索时，先从最高位次考生志愿检索。<br>遵循志愿：检索时按考生填报排列的院校顺序依次进行的，当考生的投档分符合首先被检索到的院校投档线时，该生即投到该院校，由高校择优录取，考生档案一旦投出，即不再检索该生的其它志愿。<br>一轮投档，因考生所填报的志愿是平行的，故投档检索只能进行一轮。如果考生因几个平行志愿均未满足院校条件而未被投档，或投档后由于某种客观原因被退档时，可以参加同批次征求志愿或下一批次的投档检索。',
				title3: '三、平行志愿可能后果',
				desc3: '由于平行志愿一轮投档后不可能补投。所以会出现退档、脱档、滑档现象，下面小编为大家一一解释。<br><br><div style="font-weight: 600">1.退档</div>（1）政策性退档<br>投档比例暗藏风险。高校招生实行按比例投档的办法，这种录取政策就意味着考生达线未必被录取，也就是说上线考生存在虚额。一般在市控线20分以内的“边缘生”需要格外谨慎。<br>对策：①“边缘生”尽量选择哪些往年首轮投档不满额的院校。②专业上不要过分挑拣并尽可能服从调剂。③所报考的院校要保留出一定的分数余量。④不能用录取院校的最低分来判断是否能达线。<br>（2）身体条件<br>考生对所报院校的《招生章程》中要求的报考资格、学校情况及专业要求等相关内容不了解，盲目填报，身体条件不符合所报院校或所选专业的标准。<br>对策：熟悉体检标准和特殊院校招生录取条件，避免误闯“红灯”。<br>（3）所报专业相关科目成绩偏低<br>许多高校招生不仅要求总分达到录取分数线，并且对所报专业相关科目的成绩也有一定的要求。如医学类专业对化学、生物科目的成绩要求较高。<br>对策：报考时一定要看清楚所报院校的要求。<br>（4）过高估计自身实力只选“三热”高校<br>考生在填报时只重视对热门地区的重点院校与热门专业的选择，而忽视或放弃对一般院校的填报，造成重点院校一旦失利，全盘皆输。<br>对策：注重对一般院校和相近专业的填报，选好保底院校。<br>（5）过分重视专业，不服从调剂<br>考生专业要求较高或不服从调剂（或不填写），造成进档后被退档的风险。这是高分落榜和进档后被退档主要因素。<br>对策：①专业志愿一定要“服从调剂”。②专业志愿冷热搭配要适度。<br>即使是同一院校不同的专业取分高低，不能全报热门或高分专业，要保持专业志愿间要有3-5分的差距。如对专业没有什么特殊要求，最好填上“同意调剂”。<br><br><div style="font-weight: 600">2.脱档</div>脱档是指学生一所学校都没有投进，在现在考后填报中发生的几率已经大幅度降低，以往主要出现在学生太过自信，只挂不保，结果直接脱靶。<br><br><div style="font-weight: 600">3.滑档</div>滑档即“高分低校”，也就是第一志愿没挂上之后，后面志愿梯队没有把握好，直接滑落到一所比较低的保底校。平行志愿所报的几所院校切忌“扁平”，院校之间要有梯度。<br><br><div style="font-weight: 600">4.平行志愿问题解答</div>（1）平行志愿若成功投档，但不服从调剂被退档，会看下一个志愿吗？<br>答：不会！每个批次只有一次投档机会。以本一批次为例，填报A、B、C、D、E、F6所院校。假设A院校成功进入投档范围，但是分数刚刚压线，所填6个专业都未排到录取，而又不服从调剂，被退档。则本一批次其他B、C、D、E、F5个志愿全部失效，没有机会再投档了。<br>（2）档案投出后，如被招生院校退档，是不是不能再参加其他批次投档？<br>答：平行志愿可参加征集志愿和下一批次录取。如考生已获本科第一批的A院校出档， 但其最终被A院校退档，则其无法参加本科第一批其他院校的录取，只能参加本科第一批的征集志愿录取或其填报的后续其他批次录取。<br>（3）同意调剂意味着什么？<br>如果考生所填报志愿的专业都已经录满，在考生同意专业调剂的情况下，就可能被录取到该院校在本市该批招生的任何专业。<br>如果不服从调剂，当所填报专业都无法录取时，考生将被退档。一般来说，考生只要服从调剂，高校是不会随意退回考生档案的，因此，在填平行志愿时一定要服从专业调剂。<br>（4）招办投档时会不会看学校专业的分数？<br>不会。市招办是以院校为单位进行投档，考生的档案投到高校之后，再由高校自行按分数和专业志愿等因素进行专业分配。'
			},{
				title: '顺序志愿',
				title1: '特点',
				desc1: '顺序志愿是指在同一个录取批次设置的多个院校志愿有先后顺序，如第一志愿、第二志愿等，每个志愿只包括一所院校。顺序志愿的投档原则是“志愿优先，从高分到低分”，把考生的高考志愿作为录取投档的第一要素，最大程度地满足考生的志愿要求。顺序志愿投档时，对选报同一志愿院校的考生按院校确定的录取原则、调档比例从高分到低分进行投档，也就是说每所院校各排各的队。',
				title2: '填报技巧',
				desc2: '顺序志愿的投档原则是“志愿优先，从高分到低分”。对选报同一志愿院校的考生按院校确定的调档比例从高分到低分进行投档，第一志愿录取结束后再进行第二志愿投档录取。 <br>举个例子来说，一旦考生将某高校放在第二志愿，即使你分数再高，如果该校一志愿已经招满了且不预留招收二志愿的名额，你的档案也不会投向该校。'
			},{
				title: '院校专业组',
				title1: '特点',
				desc1: '“院校专业组”由院校根据人才培养需要和不同专业(含专业或大类)的科目要求设置，是部分高考改革省份本科志愿填报与投档录取的基本单位。其特点是，一所院校可设置一个或多个院校专业组，每个院校专业组内可包含数量不等的专业。同一高校科目要求相同的专业可分设在不同的院校专业组中。同一院校专业组内各专业的科目要求须相同。',
				title2: '填报技巧',
				desc2: '传统的志愿设置是以一所学校为一个志愿单位，每个学校下可以填报若干个专业志愿和是否服从专业调剂意愿；“院校专业组”模式则以一个院校加一个专业组为一个志愿单位。将每一个志愿细化到专业组。考生根据自己的意愿可以直接选择志愿为某个学校的某个专业组，专业调剂限于同一专业组内调剂。'
			},{
				title: '专业（类）+ 学校',
				title1: '特点',
				desc1: '专业（专业类）平行志愿，是新高考招生同一类别、同一批次中若干具有相对平行关系的专业（专业类）志愿，以一所院校的一个专业（专业类）为志愿单位，按照“分数优先、遵循志愿”进行投档。',
				title2: '填报技巧',
				desc2: '不同于以往以院校为志愿单位投档的院校平行志愿，专业平行志愿投档时，直接投档到某院校某专业（专业类），不存在专业服从调剂，考生也不用担心被调剂到自己不喜欢的专业。填报志愿时一定要利用好各高校的专业投档线。'
			}],
			desc_list4: [
			{
				title: '1、什么是“3+3”模式？',
				desc: '“3+3”考试模式是3门必考+3门选考。即统一高考科目语文、数学、外语3科，加上从高中学业水平等级考试科目思想政治、历史、地理、物理、化学、生物等科目中，自主选择的3科。'
			},{
				title: '2、哪些省份施行“3+3”模式？',
				desc: '目前施行的省份为：上海、浙江、北京、天津、山东、海南。浙江省是从思想政治、历史、地理、物理、化学、生物、技术(含通用技术和信息技术)等7科中选择3科。上海高考总成绩为660分，其他省市高考总成绩为750分。'
			},{
				title: '3、什么是“3+1+2”模式？',
				desc: '3+1+2”模式为3门必考+1门首选+2门再选。即统一高考科目语文、数学、外语3科，加高中学业水平考试选择性考试物理、历史2门首选科目中所选择的1门科目，加思想政治、地理、化学、生物4门中选择的2门科目。'
			},{
				title: '4、哪些省份施行“3+1+2”模式？',
				desc: '目前施行的省份为：河北、辽宁、江苏、福建、湖北、湖南、广东、重庆。高考总成绩750分。3门必选科目总分450分，以原始分计入总成绩；1门首选科目每科满分100分，以原始分计入总成绩；2门再选科目每科满分100分，以等级赋分成绩计入考生总成绩。未来黑龙江、甘肃、吉林、安徽、江西、贵州、广西七省（区）也将采取“3+1+2”模式。'
			},{
				title: '5、普通高中学业水平考试是什么？',
				desc: '普通高中学业水平考试是根据国家普通高中课程标准和教育部有关规定，由省教育厅组织实施的国家考试，主要衡量学生达到国家规定学习要求的程度，是保障教育教学质量的一项重要制度。 <br>普通高中学业水平考试分为合格性考试和选择性(等级性)考试。合格考成绩是学生毕业、普通高中同等学力认定的主要依据；选择性(等级性)考试成绩计入普通高校统一考试招生录取的考生总成绩。'
			},{
				title: '6、合格性考试和选考的区别是什么？考试对象有什么不同？',
				desc: '合格性考试和选择性考的区别主要包括以下几个方面：一是考试目的不同。二是考试科目不同。三是考试内容不同。四是考试时间和考试次数不同。五是考试成绩呈现方式和使用不同。<br> 合格考：普通高中在校生均须参加，是学生毕业和高中同等学力认定的主要依据；选考；如学生报名参加高考，则必须按要求参加选考科目的考试。'
			},{
				title: '7、改革后，招生录取方式有什么变化？',
				desc: '高考综合改革后，普通高考招生录取志愿设置主要有两种形式。一是采用“院校专业组”的组合方式，实行平行志愿投档录取。二是采用“专业（专业类）+学校”的模式，采取一所院校一个招生专业为一个志愿，实行平行志愿投档。具体批次设置、志愿数量及录取方式按各省公布的规定执行。'
			},{
				title: '8、什么是选考科目要求？',
				desc: '高校依据教育部和生源省市有关要求，认真研究本校人才培养对高中学生学科专业基础的需要，提前制订出了本校拟招生专业的选考科目要求。'
			},{
				title: '9、在哪里查询选考科目要求？',
				desc: '考生可以登录本省考试院官方网站查询选考科目要求，作为选科的参考。因为实际招生安排中，部分高校、专业的选考科目要求可能会有一定调整变化，具体以当年公布的招生计划及院校招生章程为准。'
			},{
				title: '10、志愿填报时，考生如何注意选考科目要求？',
				desc: '考生的等级性考试（选考）科目不同，而招生院校各选考科目要求也有所不同。考生在填报志愿时，须对照院校选考科目要求，自主选择的等级性考试（选考）科目须满足报考院校选考科目要求。对于不限选考科目要求的院校专业，考生在填报时没有科目限制。'
			},{
				title: '11、什么是“院校专业组”？',
				desc: '院校专业组就是将一所院校选考科目要求相同的若干个专业合成一个组，每个组内科包含数量不等的专业，一所院校可设置多个“院校专业组”，以“院校专业组”为单位投档录取。'
			},{
				title: '12、什么是“专业（类）+院校”志愿模式？',
				desc: '“专业（类）+院校”模式是以一所学校的一个专业（类）作为一个志愿单位。投档时按照“分数优先、遵循志愿”的原则进行投档。'
			}],
			desc_list5: [
			{
				title: '院校专业组',
				city: ['福建','江苏','广东','湖南','湖北'],
				desc: '院校专业组指的是某一高校对考生选考科目要求相同的专业的组合。一所院校可设置一个或多个院校专业组，每个院校专业组内可包含数量不等的专业。<br> 同一院校专业组内各专业对考生的选考科目要求相同。同一院校选考科目要求相同的专业也可分设在不同的院校专业组中，选考科目要求不同的专业须分别设置院校专业组。<br> 例：“A大学专业组4”选考科目要求为首选科目物理、再选科目不限，包括通信工程等若干专业；“A大学专业组5”选考科目要求为首选科目物理、再选科目化学或生物，包括临床医学等若干专业。如考生拟报考A大学通信工程和临床医学2个专业，则应填报“A大学专业组4”和“A大学专业组5”两个院校专业组志愿，并分别在两个院校专业组中填报通信工程、临床医学专业志愿。'
			},{
				title: '专业（类）+学校',
				city: ['辽宁','重庆', '河北'],
				desc: '“专业（类）+学校”是以1个“专业（类）+学校”为1个志愿单位的平行志愿模式。投档时，直接投档到某院校某专业（专业类）。<br> 新的模式下，志愿单位的改变带来了数量的变化，一般来说志愿数量更多了。考生要认真查阅高校招生专业的选考科目要求，既要符合首选科目的要求，也要符合再选科目的要求。<br> 例：原来模式下同时报考A大学的数学、物理、化学3个专业，只需要填报在A大学1个单位下，新的模式下则需要填报数学+A大学，物理+A大学，化学+A大学3个志愿。<br> “专业（类）+学校”取消了专业调剂，考生不必担心被调剂到不喜欢的专业，也不存在“因不服从专业调剂而退档”问题。'
			}],
			desc_list7: [
			{
				title: '1、志愿填报的5个注意点',
				desc: '<div style="font-weight: 600">①志愿填报理智看待新设专业</div>出于市场需要，很多大学纷纷开设新兴专业，但是考虑到这些专业成立时间较短，设备和教师资源相对短缺，课程设计也不太成熟，所以考生切勿盲目跟风，一定要提前做好功课，并且一定要选择报考范围内最好的学校，才有教学质量和就业机会的基本保障。<br><br><div style="font-weight: 600">②志愿填报理智看待热门专业</div>很多考生在报考时会将热门专业作为首选，这是正确且正常的，因为热门专业就业率高、工资高、发展前景好，但是最重要的是自己是否适合学习这个专业，否则入学后发现自己完全不感兴趣，或者没有学习能力，到毕业时专业能力不强的人很难被企业认可。<br>比如计算机科学与技术专业，的确是热门专业，未来的就业前景也非常好，但是这类专业需要很好的数学等理科逻辑思维能力，学习科目难度大且枯燥，未来工作甚至比“996”还辛苦。因此在报考热门专业前一定要慎重考虑。<br><br><div style="font-weight: 600">③志愿填报要合理选择冷门专业</div>现今社会的人们大都追求快速赚钱，工作快速出成果，一些需要读研读博的研究性专业成为了冷门专业。<br>其实这些看似冷门的专业，未来的发展未必比那些热门专业差，而且很多研究性的工作如生命科学研究对人类的福祉有着重大的意义，不着急找工作，有志于这方面的学生可以考虑一下；另外如历史学、考古学等文史类专业，因为报考人数少，老师一般比较负责，没有金钱压力并且的确感兴趣的学生可以考虑。<br><br><div style="font-weight: 600">④提前了解专业内涵</div>所谓的专业内涵一般包括：专业名称、课程设置、培养体系、未来发展方向等内容。千万不要想当然的认为这个专业就是这个样子的，不要单纯凭借名字判断专业性质，不要道听途说，否则是要吃大亏的！多去查阅一些资料，多问问实际学习该专业的人，从而也判断自己是否感兴趣和具备学习该专业的能力。<br><br><div style="font-weight: 600">⑤结合自身情况选择</div>首先是你的兴趣所在，如果你对艺术感兴趣却选择了计算机，那你的大学学习生涯肯定是十分痛苦的；除了兴趣，还有自身的学习能力，徒有兴趣却学不好这个专业，那也是白搭，比如对计算机感兴趣，但是数学不好，没有专业能力也不好就业。<br>再就是家庭情况，如果是比较普通的家庭，自己又没有什么额外的收入来源，却选择了艺术专业，除非天赋使然，能赚钱，不然还是暂时委屈一下，将其当做一个兴趣，但不要抛弃，有一份能养活自己的本职工作后，再去发展这个兴趣，相信自己总会有机会的。'
			},
			{
				title: '2、志愿填报，哪些参考材料是必须的？',
				desc: '首先仔细查阅省招办下发的高校招生计划。认真研读报考院校当年招生章程，其中特别是各专业对考生的要求，如体检、外语语种、单科成绩、综合素质评价等是否符合报考条件。然后参考省招办发布的填报志愿手册或录取分数分布统计等资料，结合考生成绩位次和各类别总分（或综合分）一分一段表，认真分析近三年招生院校和专业的录取信息。了解你所报考批次的招生录取相关办法和规定，知晓自己所在类别的志愿设置和投档录取规则。收集分析多种信息，做好填报志愿前的功课。'
			},{
				title: '3、考生填报志愿一般要考虑哪些因素？',
				desc: '一是以成绩为基础。高考成绩是考生被录取的基础因素，直接决定了可选择的院校和专业去向。 <br>二是院校综合情况。院校是考生选择志愿的重要因素，是选择与哪些人在一起学习、到哪里去学习、学些什么等问题。考生在选择时，既要看院校的历史、地域，也要看院校综合办学实力。 <br>三是考虑兴趣爱好、专业就业等因素。专业是考生志愿选择的核心因素，一般关系到学生的学习兴趣和职业趋向。重点大学有优势专业、普通院校也有特色专业，是院校优先还是专业优先，不能一概而论；考生要选自己喜欢、符合个性特长的专业，改革省份考生还要考虑选考科目范围等因素。专业选择与经济社会发展的趋势有关，有的专业报考很热门，到了就业却遇冷，需要理性判断。 <br>四是结合身体等条件。专业与身体状况有关联，有的专业受视力、色觉、器质性健康状况的限制；部分院校按专业学习要求，会对单科成绩和外语口语等方面提出要求。还有一些中外合作专业、民办院校收费较高，选报时还应考虑家庭经济状况。 <br>五是注意志愿之间梯度的问题，建议高、中、低搭配填报，较为合理，避免退档风险。'
			},{
				title: '4、新高考模式下，专业平行志愿填报有哪些参考策略？',
				desc: '填报高考志愿方法很多，可根据不同情况先选院校再选专业，或者先选专业再选院校，只要适合自己就好。这里简单谈一谈专业平行志愿填报策略：<br> 第一步：选择不同梯度的院校。根据考生位次和分数段统计表、各校往年投档线等资料，选择不同梯次的院校。“冲、稳、保”选择院校的办法还是可以使用的。<br> 第二步：筛选不同梯次的专业。从选定的院校中，根据往年专业录取情况，将其中不喜欢的专业或是估计录取可能性不大的专业删除，筛选出拟报考的不同梯次的专业。<br> 第三步：根据个人意愿，综合考虑院校性质、地域、喜欢程度等因素，从高到低排列，正式确定志愿。这里要特别提醒，考生在填报志愿时一定要特别重视院校的招生章程，确保符合报考条件。'
			},{
				title: '5、新高考模式下，专业报考要注意什么？',
				desc: '新高考中由于考生选考科目不同，高校对选考科目的要求也不同，高考改革省份考生在选专业前应尽早了解所在省市发布的专业选考科目要求。如果你已有了心仪的院校，可以从学校入手。如果以专业为目标来划定院校范围，则要注意相同专业在不同高校可能会有不同选考要求。如A大学经济学类专业选考科目要求，考生需选考物理或化学其中一门才可报考，而B大学经济学类专业不限选考科目要求。另外，有些专业培养与多个科目关联度都高，高校在可选科目中指定2个或3个选考科目，要求为考生“均须选考”的情况也需要注意。<br> 如果你没有目标院校或专业，在选择时，可以多参考“不限选考科目”的院校专业，扩大自己的专业选择面。由于高校的院系及专业（类）调整等因素，实际招生高校和招生专业（类）也可能会调整变化，考生要以高校当年公布的招生计划及院校招生章程为准。'
			}],
			grade_list: [{
				id: '3',
				title: '全国统一考试',
				total_score: '450分',
				subject: [{ name:'语文', score:'150分'},{ name:'数学', score:'150分'},{ name:'外语', score:'150分'}]
			},{
				id: '1',
				title: '首选科目2选1',
				total_score: '100分',
				subject: [{ name:'物理', score:'100分'},{ name:'历史', score:'100分'}]
			},{
				id: '2',
				title: '再选科目4选2',
				total_score: '200分',
				subject: [{ name:'政治', score:'100分'},{ name:'地理', score:'100分'},{ name:'化学', score:'100分'},{ name:'生物', score:'100分'}]
			}],
			new_list: []
		}
	},
	mounted() {
		this.getGuideList()
	},
	methods: {
		changeDescActive(index) {
			this.active_index = index
		},
		getGuideList() {
			getGuideList().then(res => {
				if(res.data.length === 0) {
					this.requestStatus = '2'
					return
				}
				this.new_list = res.data.map(item => {
					let new_tmp = {
						list: [],
						id: item.id
					}
					if (item.news_title.indexOf('：') !== -1) {
						new_tmp.list = item.news_title.split('：')
					}else if (item.news_title.indexOf(':') !== -1) {
						new_tmp.list = item.news_title.split(':')
					} else {
						new_tmp.list[1] = item.news_title.split('：')[0]
					}
					return new_tmp
				})
			})
		},
	 	goDetailHandler(id) {
      		this.$router.push({
				path:'/guideDetail',
          		query: {
	              	id: id
	          	}
			})
	    }
	}
}
</script>
<style lang="scss" scoped>
	@import "@/assets/css/variables.scss";
	.guide-box {
		width: 100%;
		.guide-bg-box {
			background: url('../../assets/images/gk-guide-img1.png');
			height: 512px;
			background-size: cover;
			background-position: center;
		}
		.guide-infor-box {
			height: 278px;
			background: #7b71f4;
			padding-top: 28px;
			box-sizing: border-box;
		}
		.guide-infor-bg {
			width: 1200px;
			margin: 0 auto;
			background: url('../../assets/images/gk-guide-img2.png');
			height: 210px;
			background-size: cover;
			background-position: center;
			font-size: 20px;
			color: #3736aa;
			line-height: 40px;
			padding: 53px 41px 37px 41px;
			box-sizing: border-box;
			// display: flex;
			// justify-content: center;
			// align-item: center;
		}
		.guide-tips-box {
			width: 1200px;
			margin: 0 auto;
			.guide-tips-title {
				display: flex;
				justify-content: space-between;
				margin: 56px 0 64px 0;
				.guide-tips-title-item {
					width: 163px;
					height: 58px;
					background: #edecff;
					border: 2px solid #090e78;
					border-radius: 31px;
					font-size: 18px;
					font-weight: 700;
					text-align: center;
					color: #332e2c;
					line-height: 58px;
					cursor: pointer;
				}
				.guide-tips-title-item-active {
					color: #895ee1;
					background: #ffffff;
					border: 2px solid #090e78;
				}
			}
			.guide-desc-common-box {
				h3 {
					font-size: 28px;
					font-weight: 700;
					text-align: center;
					color: #3736aa;
					line-height: 40px;
					position: relative;
					margin: 0;
					margin-bottom: 64px;
					span {
						position: relative;
						z-index: 999;
					}
				}
				.guide-desc-line {
					position: absolute;
					width: 112px;
					height: 15px;
					background: #e99080;
					left: 50%;
					transform: translateX(-50%);
					bottom: 0px;
					z-index: 0;
				}
				.guide-desc-common-item {
					background: #ffffff;
					border-radius: 8px;
					padding: 32px 40px;
					margin-bottom: 20px;
					h5 {
						font-size: 22px;
						font-weight: 700;
						color: #332e2c;
						line-height: 30px;
						margin: 0;
					}
					p {
						font-size: 16px;
						font-weight: 400;
						color: #66605e;
						line-height: 32px;
						margin: 0;
						margin-top: 12px;
					}
				}
			}
			.guide-desc-zhengce-box {
				.el-col-13 {
					padding-right: 38px;
				}
			}
			.guide-desc-zhiyuan-box {
				h4 {
					font-size: 24px;
					font-weight: 700;
					text-align: left;
					color: #3736aa;
					line-height: 33px;
					margin: 0;
				}
				h5 {
					margin-top: 20px!important;
					font-size: 18px!important;
				}
			}
			.guide-desc-gaige-box {
				>h4 {
					font-size: 18px;
					font-weight: 400;
					color: #5e6166;
					line-height: 36px;
					margin: 0 0 24px 0;
				}
			}
			.guide-desc-yaoqiu-box {
				.guide-desc-line {
					width: 168px;
				}
				i {
					float: right;
					color: #c4c7cc;
					font-size: 16px;
					margin-top: 8px;
				}
				.el-icon-arrow-right-diff {
					margin-top: 19px;
				}
				.guide-desc-common-item {
					height: 136px;
					box-sizing: border-box;
					cursor: pointer;
					p {
					  white-space: nowrap;
					  overflow: hidden;
					  text-overflow: ellipsis;
					}
				}
			}
			.guide-desc-moshi-box {
				.guide-desc-line {
					width: 160px;
				}
				>h4 {
					font-size: 18px;
					font-weight: 400;
					text-align: center;
					color: #5e6166;
					line-height: 36px;
					margin: 0 0 24px 0;
				}
				h5 {
					font-size: 24px!important;
					font-weight: 700!important;
					color: #3736aa!important;
					line-height: 33px!important;
				}
				.guide-desc-moshi-title {
					width: 218px;
					height: 58px;
					background: #7b71f4;
					border: 2px solid #1a1d8a;
					border-radius: 8px;
					font-size: 24px;
					font-weight: 700;
					text-align: center;
					color: #ffffff;
					line-height: 58px;
					margin: 0 auto;
					margin-bottom: 32px;
				}
				.guide-desc-moshi-city {
					margin: 16px 0 12px 0;
					span {
						display: inline-block;
						margin-right: 16px;
						width: 100px;
						height: 48px;
						background: #f5f1ff;
						border-radius: 8px;
						font-size: 18px;
						font-weight: 700;
						text-align: center;
						color: #5e6166;
						line-height: 48px;
					}
				}
				.guide-moshi-grade-box {
					width: 1200px;
					margin: 0 auto;
					background: #ffffff;
					border-radius: 8px;
					margin-bottom: 64px;
					padding: 65px 40px 32px 40px;
					text-align: center;
					position: relative;
					box-sizing: border-box;
					.guide-moshi-grade-item {
						display: flex;
						justify-content: space-between;
						> div {
							position: relative;
						}
						.guide-moshi-subject-box {
							width: 316px;
							height: 384px;
							background: #ffffff;
							border: 1px solid #dddddd;
							border-radius: 8px;
							position: relative;
							.guide-moshi-subject-index {
								position: absolute;
								left: 50%;
								transform: translateX(-50%);
								top: -17px;
								width: 56px;
								height: 56px;
								background: #e99080;
								border: 2px solid #c5513d;
								border-radius: 8px;
								font-size: 28px;
								font-weight: 700;
								text-align: center;
								color: #ffffff;
								line-height: 56px;
							}
							h4 {
								font-size: 20px;
								font-weight: 700;
								text-align: center;
								color: #3736aa;
								line-height: 28px;
								margin-top: 50px;
								margin-bottom: 2px;
							}
							.guide-moshi-subject-item {
								margin-top: 10px;
								span {
									font-size: 24px;
									font-weight: 700;
									line-height: 33px;
									color: #7b71f4;
								}
								span:first-child {
									color: #332e2c;
									margin-right: 40px;
								}
							}
						}
						.guide-moshi-grade-add {
							position: absolute;
							color: #bebdfa;
							font-size: 72px;
							transform: translateY(-50%);
							top: 50%;
							right: -64px;
						}
					}
					.guide-moshi-grade-total {
						width: 262px;
						// height: 80px;
						background: #84abfe;
						border: 2px solid #090e78;
						border-radius: 46px;
						padding: 10px 0;
						position: absolute;
						bottom: 32px;
						left: 50%;
						transform: translateX(-50%);
						h6 {
							font-size: 14px;
							font-weight: 400;
							color: #ffffff;
							line-height: 20px;
							margin: 0;
						}
						h3 {
							font-size: 28px;
							font-weight: 700;
							color: #ffffff;
							line-height: 40px;
							margin: 0;
						}
					}
					.guide-moshi-grade-deng {
						color: #bebdfa;
						font-size: 86px;
						margin: -12px 0;
					}
					.guide-moshi-grade-total-diff {
						position: relative;
						bottom: 0;
						margin-top: 12px;
					}
				}
			}
		}
		 .no-data-box {
		    position: relative;
		    top: 90px;
		    left: 50%;
		    transform: translate(-50%, -50%);
		    text-align: center;
		    margin-top: 50px;
		    img {
		        width: 110px;
		        height: 110px;
		    }
		    p {
		        font-size: 16px;
		        // text-align: center;
		        color: #666666;
		        margin-left: -14px;
		    }
		}
	}
</style>